// ------------ A C U E R D O S    I T E ------------
export const dataAcuerdos2026 = [
  {
    id: 1,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc: "POR EL QUE SE ACTUALIZA LA CALENDARIZACIÓN DE LAS CANTIDADES A RETENER POR MULTAS PENDIENTES POR PAGAR Y SE CALENDARIZA LA RETENCIÓN DE MULTAS A PARTIDOS POLITICOS, AMBOS SUPUESTOS DERIVADOS DE RESOLUCIONES Y ACUERDOS DEL INSTITUTO NACIONAL ELECTORAL Y DE ESTE INSTITUTO. ",
    titleAnexo1: "ANEXO UNO",
    titleAnexo2: "ANEXO DOS",
  },
  {
    id: 2,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc: "POR EL QUE SE APRUEBA EL INFORME DE OTORGAMIENTO DE INCENTIVOS 2025, CORRESPONDIENTE AL EJERCICIO VALORADO 2024, A PERSONAL DEL SERVICIO PROFESIONAL ELECTORAL NACIONAL DE ESTE INSTITUTO",
    titleAnexo1: "ANEXO UNICO",
  },
  {
    id: 3,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc: "POR EL QUE SE CALENDARIZA LA RETENCIÓN DE LA MULTA PREVISTA EN LA RESOLUCIÓN INE/CG2107/2024, DEL INSTITUTO NACIONAL ELECTORAL.",
    titleAnexo1: "ANEXO UNICO",
  },
  {
    id: 4,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc: "POR EL QUE SE READECÚA EL PRESUPUESTO DE EGRESOS DEL EJERCICIO FISCAL DOS MIL VEINTISÉIS, DE ESTE INSTITUTO.",
    titleAnexo1: "ANEXO UNICO",
  },
  {
    id: 5,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc: "POR EL QUE SE APRUEBA EL PROGRAMA DE IMPARTICIÓN DE SEMINARIOS, CONFERENCIAS, COLOQUIOS, DIPLOMADOS, MESAS REDONDAS, DIVULGACIÓN DE TEXTOS, PUBLICACIÓN DE RESULTADOS DE INVESTIGACIÓN Y PRESENTACIÓN DE LIBROS 2026, ELABORADO POR LA JUNTA GENERAL EJECUTIVA.",
    titleAnexo1: "ANEXO UNICO",
  },
  {
    id: 6,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc: "POR EL QUE SE ESTABLECE EL PROCEDIMIENTO PARA LA EJECUCIÓN DE LAS MULTAS PREVISTAS EN LA RESOLUCIÓN INE/CG985/2025 MODIFICADA MEDIANTE LOS ACUERDOS INE/CG1339/2025, INE/CG1341/2025, INE/CG1403/2025 E INE/CG1404/2025 DEL INSTITUTO NACIONAL ELECTORAL.",
  },
  {
    id: 7,
    typeDoc: "ACUERDO",
    monthDoc: "FEB",
    nameDoc: "POR EL QUE SE APRUEBA EL DICTAMEN GENERAL DE RESULTADOS DE LA EVALUACIÓN DEL DESEMPEÑO DEL PERSONAL DEL SERVICIO PROFESIONAL ELECTORAL NACIONAL DEL SISTEMA DE LOS ORGANISMOS PÚBLICOS LOCALES ELECTORALES, CORRESPONDIENTE AL PERIODO SEPTIEMBRE 2024 A AGOSTO 2025.",
    titleAnexo1: "ANEXO UNICO",
  },
  {
    id: 8,
    typeDoc: "RESOLUCION",
    monthDoc: "FEB",
    nameDoc: "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PAN-CFyCT/CG/011/2025.",
  },
  {
    id: 9,
    typeDoc: "RESOLUCION",
    monthDoc: "FEB",
    nameDoc: "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PT/CG/010/2025.",
  },
  {
    id: 10,
    typeDoc: "RESOLUCION",
    monthDoc: "FEB",
    nameDoc: "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/MC/CG/009/2025.",
  },
  {
    id: 11,
    typeDoc: "RESOLUCION",
    monthDoc: "FEB",
    nameDoc: "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/CA/CG/080/2025.",
  },
  {
    id: 12,
    typeDoc: "RESOLUCION",
    monthDoc: "FEB",
    nameDoc: "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/CA/CG/081/2025.",
  },
  {
    id: 13,
    typeDoc: "RESOLUCION",
    monthDoc: "MAR",
    nameDoc: "RESPECTO DE LA SOLICITUD DE ADOPTAR MEDIDAS CAUTELARES DENTRO DEL CUADERNO DE ANTECEDENTES CQD/CA/CG/079/2025; EN CUMPLIMIENTO A LA SENTENCIA DICTADA POR EL PLENO DEL TRIBUNAL ELECTORAL DE TLAXCALA, DENTRO DEL EXPEDIENTE ELECTORAL TET-JE-019/2026.",
  },
  {
    id: 14,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc: "POR EL QUE SE APRUEBA REALIZAR LAS CONSULTAS DIRIGIDAS A PERSONAS, PUEBLOS Y COMUNIDADES INDÍGENAS, PERSONAS CON DISCAPACIDAD Y POBLACIONES LGBTTTIQA+, PARA LA IMPLEMENTACIÓN DE ACCIONES AFIRMATIVAS EN EL MARCO DEL PRÓXIMO PROCESO ELECTORAL LOCAL ORDINARIO 2026-2027. ",
    titleAnexo1: "ANEXO UNO",
    titleAnexo1_1: "SUBANEXO UNO DEL ANEXO UNO",
    titleAnexo1_2: "SUBANEXO DOS DEL ANEXO UNO",
    titleAnexo2: "ANEXO DOS",
    titleAnexo3: "ANEXO TRES",
    titleAnexo4: "ANEXO CUATRO",
    titleAnexo4_1: "SUBANEXO UNO DEL ANEXO CUATRO",
    titleAnexo4_2: "SUBANEXO DOS DEL ANEXO CUATRO",
    titleAnexo5: "ANEXO CINCO",
    titleAnexo6: "ANEXO SEIS",
    titleAnexo7: "ANEXO SIETE",
    titleAnexo8: "ANEXO OCHO",
    titleAnexo9: "ANEXO NUEVE",
    titleAnexo10: "ANEXO DIEZ",
    titleAnexo10_1: "SUBANEXO UNO DEL ANEXO DIEZ",
  },
  {
    id: 15,
    typeDoc: "RESOLUCION",
    monthDoc: "ABR",
    nameDoc: "POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO A LA MODIFICACIÓN DE LOS ESTATUTOS DEL PARTIDO POLÍTICO LOCAL NUEVA ALIANZA TLAXCALA.",
    titleAnexo1: "FE DE ERRATAS",
  },
  {
    id: 16,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc: "RELATIVO A LA SOLICITUD DE ADOPTAR MEDIDAS CAUTELARES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PRDT/CG/037/2026.",
    titleAnexo1: "VOTO PARTICULAR CONSEJERA YEDITH MARTÍNEZ PINILLO",
  },
  {
    id: 17,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc: "POR EL QUE SE APRUEBA EL DICTAMEN RELATIVO A LA PROCEDENCIA DE LA ROTACIÓN, POR NECESIDADES DEL SERVICIO, DEL PERSONAL DEL SERVICIO PROFESIONAL ELECTORAL NACIONAL ADSCRITO AL INSTITUTO.",
    titleAnexo1: "ANEXO UNICO",
  },
  {
    id: 18,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc: "RELATIVO A LA SOLICITUD DE ADOPTAR MEDIDAS CAUTELARES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/JPCR/039/2026.",
  },
  {
    id: 19,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc: "POR EL QUE SE CALENDARIZA LA RETENCIÓN DE LAS MULTAS IMPUESTAS A LOS PARTIDOS POLITICOS ACCIÓN NACIONAL Y MOVIMIENTO CIUDADANO, DERIVADAS DE LAS RESOLUCIONES ITE-CG 08/2026 E ITE-CG 10/2026.",
    titleAnexo1: "ANEXO UNICO",
  },
  {
    id: 20,
    typeDoc: "RESOLUCION",
    monthDoc: "ABR",
    nameDoc: "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/MACC/CG/066/2025.",
  },
  {
    id: 21,
    typeDoc: "ACUERDO",
    monthDoc: "MAY",
    nameDoc: "POR EL QUE SE DA CUMPLIMIENTO A LA SENTENCIA EMITIDA POR EL TRIBUNAL ELECTORAL DE TLAXCALA DICTADA DENTRO DEL EXPEDIENTE NÚMERO TET-JDC-021/2026.",
  },
  {
    id: 22,
    typeDoc: "ACUERDO",
    monthDoc: "MAY",
    nameDoc: "POR EL QUE SE CALENDARIZA LA RETENCIÓN DE MULTAS IMPUESTAS A LOS PARTIDOS POLÍTICOS ACCIÓN NACIONAL, REVOLUCIONARIO INSTITUCIONAL, DEL TRABAJO, MOVIMIENTO CIUDADANO, MORENA Y FUERZA POR MÉXICO TLAXCALA, DERIVADAS DE LA RESOLUCIÓN INE/CG2012/2024 MODIFICADA MEDIANTE LOS ACUERDOS INE/CG2250/2024 E INE/CG2260/2024, ASÍ COMO EN LAS RESOLUCIONES INE/CG90/2026, INE/CG91/2026, INE/CG93/2026, INE/CG95/2026, INE/CG96/2026 E INE/CG97/2026, EMITIDAS POR EL INSTITUTO NACIONAL ELECTORAL.",
    titleAnexo1: "ANEXO UNICO",
  },
  {
    id: 23,
    typeDoc: "RESOLUCION",
    monthDoc: "MAY",
    nameDoc: "DICTADO POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PRI/CG/067/2025. ",
  },
  {
    id: 24,
    typeDoc: "RESOLUCION",
    monthDoc: "MAY",
    nameDoc: "DICTADO POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PAC/CG/068/2025.",
  },
  {
    id: 25,
    typeDoc: "RESOLUCION",
    monthDoc: "MAY",
    nameDoc: " DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/RSPT/CG/069/2025. ",
  },
  {
    id: 26,
    typeDoc: "RESOLUCION",
    monthDoc: "MAY",
    nameDoc: " DEL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/DLH/CG/070/2025. ",
  },
  {
    id: 27,
    typeDoc: "ACUERDO",
    monthDoc: "JUN",
    nameDoc: " RELATIVO A LA SOLICITUD DE ADOPTAR MEDIDAS CAUTELARES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/JPCR/CG/038/2026. ",
    titleAnexo1: "VOTO CONCURRENTE CE BRENDA FERNANDA BARRON",
    titleAnexo2: "VOTO CONCURRENTE CE HERMENEGILDO NERIA",
    titleAnexo3: "VOTO CONCURRENTE CE YEDITH MARTINEZ ",
  },
  {
    id: 28,
    typeDoc: "ACUERDO",
    monthDoc: "JUN",
    nameDoc: " RELATIVO A LA SOLICITUD DE ADOPTAR MEDIDAS CAUTELARES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/JPCR/CG/046/2026.",
    titleAnexo1: "VOTO CONCURRENTE CE BRENDA FERNANDA BARRON",
    titleAnexo2: "VOTO CONCURRENTE CE HERMENEGILDO NERIA",
    titleAnexo3: "VOTO CONCURRENTE CE YEDITH MARTINEZ ",
  },
  {
    id: 29,
    typeDoc: "ACUERDO",
    monthDoc: "JUN",
    nameDoc: " POR EL QUE SE DA RESPUESTA AL ESCRITO PRESENTADO POR LA CIUDADANA TEODORA CUCHILLO TIZATL. ",
  },
  {
    id: 30,
    typeDoc: "ACUERDO",
    monthDoc: "JUN",
    nameDoc: " POR EL QUE SE REFORMA EL REGLAMENTO INTERIOR Y SE APRUEBA EL REGLAMENTO EN MATERIA DE TRANSPARENCIA Y ACCESO A LA INFORMACIÓN PÚBLICA AMBOS DEL INSTITUTO TLAXCALTECA DE ELECCIONES.",
    titleAnexo1: "ANEXO UNO",
    titleAnexo2: "ANEXO DOS",
  },
  {
    id: 31,
    typeDoc: "ACUERDO",
    monthDoc: "JUN",
    nameDoc: "POR EL QUE SE DA CUMPLIMIENTO A LA SENTENCIA EMITIDA POR EL TRIBUNAL ELECTORAL DE TLAXCALA, DENTRO DEL EXPEDIENTE ELECTORAL TET-JE-051/2026.",
  },
  {
    id: 32,
    typeDoc: "RESOLUCION",
    monthDoc: "JUN",
    nameDoc: "DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PAN/CG/007/2026.",
  },
  {
    id: 33,
    typeDoc: "RESOLUCION",
    monthDoc: "JUN",
    nameDoc: "DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/ATL/CG/018/2026.",
  },
  {
    id: 34,
    typeDoc: "RESOLUCION",
    monthDoc: "JUN",
    nameDoc: "POR LA QUE SE DA CUMPLIMIENTO A LA SENTENCIA DICTADA POR EL TRIBUNAL ELECTORAL DE TLAXCALA, DENTRO DEL JUICIO ELECTORAL TETJE-057/2026 RELATIVA AL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/MACC/CG/066/2025.",
  },
  {
    id: 35,
    typeDoc: "ACUERDO",
    monthDoc: "JUN",
    nameDoc: "POR EL QUE SE APRUEBA LA MODIFICACIÓN DEL PROTOCOLO PARA EL PROCESO DE CONSULTA PREVIA, LIBRE, INFORMADA Y ANÓNIMA EN MATERIA DE AUTOADSCRIPCIÓN A LAS POBLACIONES LGBTTTIQA+, PARA LA IMPLEMENTACIÓN DE ACCIONES AFIRMATIVAS EN EL MARCO DEL PRÓXIMO PROCESO ELECTORAL LOCAL ORDINARIO 2026-2027.",
  },
  {
    id: 36,
    typeDoc: "ACUERDO",
    monthDoc: "JUL",
    nameDoc: "RELATIVO A LA SOLICITUD DE ADOPTAR MEDIDAS CAUTELARES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/JCHP/CG/073/2026.",
  },
  {
    id: 37,
    typeDoc: "RESOLUCION",
    monthDoc: "JUL",
    nameDoc: "POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO A LA MODIFICACIÓN DE LOS DOCUMENTOS BÁSICOS DEL PARTIDO POLÍTICO LOCAL NUEVA ALIANZA TLAXCALA.",
  },
  {
    id: 38,
    typeDoc: "ACUERDO",
    monthDoc: "JUL",
    nameDoc: "POR EL QUE SE CALENDARIZA LA RETENCIÓN DE LAS MULTAS IMPUESTAS A LOS PARTIDOS POLÍTICOS MORENA, REVOLUCIONARIO INSTITUCIONAL Y ALIANZA CIUDADANA DERIVADAS DE LAS RESOLUCIONES INE/CG2012/2024 E INE/CG673/2025 EMITIDAS POR EL INSTITUTO NACIONAL ELECTORAL, ITE-CG 23/2026 E ITE-CG 24/2026 DE ESTE INSTITUTO Y SE DA INSTITUCIONAL.",
    titleAnexo1: "ANEXO UNO",
  },
  {
    id: 39,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc: "POR EL QUE SE DESIGNA A LA PERSONA TITULAR DE LA SECRETARÍA EJECUTIVA DE ESTE INSTITUTO. ",
  },
  {
    id: 40,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc: "POR EL QUE SE DETERMINA LA NECESIDAD DE DESIGNAR UNA ENCARGADURÍA DE DESPACHO DE LA SECRETARÍA EJECUTIVA DE ESTE INSTITUTO, EN TANTO SE DESIGNA A LA PERSONA TITULAR.  ",
    titleAnexo1: "VOTO CONCURRENTE CE BRENDA FERNANDA BARRÓN RUGERIO",
  },
  {
    id: 41,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc: "POR EL QUE SE READECÚA EL PRESUPUESTO DE EGRESOS DEL EJERCICIO FISCAL DOS MIL VEINTISÉIS, DE ESTE INSTITUTO. ",
    titleAnexo1: "ANEXO UNICO",
  },
  {
    id: 42,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc: "POR EL QUE SE APRUEBA LA ACREDITACIÓN DEL PARTIDO POLÍTICO NACIONAL DENOMINADO “PARTIDO PAZ” ANTE EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES.",
  },
  {
    id: 43,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc: "POR EL QUE SE APRUEBA LA ACREDITACIÓN DEL PARTIDO POLÍTICO NACIONAL DENOMINADO “SOMOS MÉXICO” ANTE EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES. ",
  },
  {
    id: 44,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc: "RELATIVO A LA SOLICITUD DE ADOPTAR MEDIDAS CAUTELARES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADORCQD/Q/PAN/CG/111/2026.",
  },

  {
    id: 45,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc: "POR EL QUE SE REDISTRIBUYE EL FINANCIAMIENTO PÚBLICO DE LOS PARTIDOS POLÍTICOS CON REGISTRO Y ACREDITACIÓN ANTE EL ITE, DERIVADO DE LA ACREDITACIÓN DE LOS PARTIDOS POLÍTICOS NACIONALES SOMOS MÉXICO Y PAZ.",
    titleAnexo1: "ANEXO 1. ACTIVIDADES ORDINARIAS",
    titleAnexo2: "ANEXO 2. ACTIVIDADES ESPECÍFICAS",
  },

  {
    id: 46,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc: "POR EL QUE SE ACTUALIZA LA CALENDARIZACIÓN DE LAS CANTIDADES A RETENER POR MULTAS PENDIENTES POR PAGAR Y SE CALENDARIZA LA RETENCIÓN DE MULTAS A PARTIDOS POLITICOS, AMBOS SUPUESTOS DERIVADOS DE RESOLUCIONES Y ACUERDOS DEL INE E ITE.",
    titleAnexo1: "ANEXO 1. ACTUALIZACIÓN DE LA EJECUCIÓN DE LAS SANCIONES",
    titleAnexo2: "ANEXO 2. CALENDARIZADO DE MULTAS",
  },

  {
    id: 47,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc: "POR EL QUE SE DETERMINA LA COMISIÓN QUE DARÁ SEGUIMIENTO AL DISEÑO, IMPLEMENTACIÓN Y OPERACIÓN DEL PROGRAMA DE RESULTADOS ELECTORALES PRELIMINARES Y SE RATIFICA LA INSTANCIA INTERNA RESPONSABLE DE COORDINAR EL DESARROLLO DE LAS ACTIVIDADES DEL PROGRAMA EN MENCIÓN, PARA EL PROCESO ELECTORAL LOCAL ORDINARIO 2026-2027.",
  },

  {
    id: 48,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc: "POR EL QUE SE DETERMINA LA COMISIÓN EN LA QUE SE REPORTEN LOS TRABAJOS DE IMPLEMENTACIÓN Y OPERACIÓN DEL SISTEMA “CANDIDATAS Y CANDIDATOS, CONÓCELES” PARA EL PROCESO ELECTORAL LOCAL ORDINARIO 2026-2027.",
  },
  {
    id: 49,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "AGO",
    nameDoc: "DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PRI/CG/008/2026.",
  },

  {
    id: 50,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "AGO",
    nameDoc: "DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PT/CG/009/2026.",
  },

  {
    id: 51,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "AGO",
    nameDoc: "DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/CHC/CG/017/2026.",
  },

  {
    id: 52,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "AGO",
    nameDoc: "DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/ATL/CG/019/2026.",
  },

  {
    id: 53,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "AGO",
    nameDoc: "DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/CUA/CG/020/2026",
  },

  {
    id: 54,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "AGO",
    nameDoc: "DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/NMA/CG/021/2026.",
  },

  {
    id: 55,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "AGO",
    nameDoc: "DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/TES/CG/024/2026.",
  },


  {
    id: 56,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "AGO",
    nameDoc: "DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/SAT/CG/028/2026.",
  },

  {
    id: 57,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc: "POR EL QUE SE APRUEBA EL INFORME GENERAL RELATIVO A LA VERIFICACIÓN DEL CUMPLIMIENTO DEL NÚMERO MÍNIMO DE PERSONAS AFILIADAS A LOS PARTIDOS POLÍTICOS LOCALES.",
    titleAnexo1: "ANEXO 1. INFORME GENERAL RELATIVO A LA VERIFICACIÓN DEL CUMPLIMIENTO DEL NÚMERO MÍNIMO DE PERSONAS AFILIADAS A LOS PARTIDOS POLÍTICOS LOCALES.",
  },

  {
    id: 58,
    typeDoc: "ACUERDO",
    monthDoc: "AGO",
    nameDoc: "RELATIVO A LA SOLICITUD DE ADOPTAR MEDIDAS CAUTELARES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/AJVC/CG/103/2026.",
  },
  {
    id: 59,
    typeDoc: "ACUERDO",
    monthDoc: "SEP",
    nameDoc: "POR EL QUE SE DESIGNA A LA PERSONA TITULAR DE LA SECRETARÍA EJECUTIVA DE ESTE INSTITUTO.",
  },

  {
    id: 60,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "SEP",
    nameDoc: "POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO A LA MODIFICACIÓN DE LOS ESTATUTOS DEL PARTIDO POLÍTICO LOCAL FUERZA POR MÉXICO TLAXCALA.",
  },


  {
    id: 61,
    typeDoc: "RESOLUCIÓN",
    monthDoc: "SEP",
    nameDoc: "POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO A LA MODIFICACIÓN DE LOS DOCUMENTOS BÁSICOS DEL PARTIDO POLÍTICO LOCAL REDES SOCIALES PROGRESISTAS TLAXCALA.",
    titleAnexo1: "PROGRAMA DE ACCIÓN. PARTIDO ENCUENTRO SOLIDARIO TLAXCALA",
    titleAnexo2: "DECLARACIÓN DE PRINCIPIOS. PARTIDO ENCUENTRO SOLIDARIO TLAXCALA.",
    titleAnexo3: "ESTATUTOS PARTIDO ENCUENTRO SOLIDARIO TLAXCALA",
    titleAnexo4: "VOTO PARTICULAR QUE FORMULA LA CONSEJERA ELECTORAL MTRA. BRENDA FERNANDA BARRÓN RUGERIO.",
    titleAnexo5: "VOTO PARTICULAR QUE EMITE EL CONSEJERO PRESIDENTE EMMANUEL ÁVILA GONZÁLEZ.",
  },
  {
    id: 62,
    typeDoc: "ACUERDO",
    monthDoc: "SEP",
    nameDoc: "POR EL QUE SE APRUEBA EL DICTAMEN PARA EL OTORGAMIENTO DE INCENTIVOS, A EFECTUAR EN 2026, CORRESPONDIENTE AL EJERCICIO VALORADO 2025 A PERSONAL DEL SERVICIO PROFESIONAL ELECTORAL NACIONAL DEL ITE.",
    titleAnexo1: "DICTAMEN PARA EL OTORGAMIENTO DE INCENTIVOS 2026 CORRESPONDIENTE AL EJERCICIO VALORADO 2025 A PERSONAL DEL SERVICIO PROFESIONAL ELECTORAL NACIONAL.",

  },

  {
    id: 63,
    typeDoc: "ACUERDO",
    monthDoc: "SEP",
    nameDoc: "POR EL QUE SE DETERMINA QUE LA OPERACIÓN DEL SISTEMA “CANDIDATAS Y CANDIDATOS CONÓCELES” ESTARÁ A CARGO DE ESTE INSTITUTO, DURANTE EL PROCESO ELECTORAL LOCAL ORDINARIO 2026-2027.",
  },

  {
    id: 64,
    typeDoc: "ACUERDO",
    monthDoc: "SEP",
    nameDoc: "POR EL QUE SE APRUEBA EL PROYECTO DE PRESUPUESTO DE EGRESOS DEL ITE PARA EL EJERCICIO FISCAL 2027.",
    titleAnexo1: "ANTEPROYECTO DE PRESUPUESTO DE EGRESOS 2027",
    titleAnexo2: "ACTIVIDADES ORDINARIAS ANUALES.",
    titleAnexo3: "ACTIVIDADES TENDIENTES A LA OBTENCIÓN DEL VOTO.",
    titleAnexo4: "ACTIVIDADES ESPECÍFICAS ANUALES.",
  },

];

// ------------ A C U E R D O S    I N E ------------
export const dataAcuerdosINE2026 = [
  {
    id: 171,
    typeDoc: "ACUERDO",
    numDoc: "INE/CG171/2026",
    nameDoc:
      "ACUERDO DEL CONSEJO GENERAL DEL INSTITUTO NACIONAL ELECTORAL POR EL QUE SE APRUEBAN LAS CONVOCATORIAS PARA EL PROCESO DE SELECCIÓN Y DESIGNACIÓN DE LAS PRESIDENCIAS DE LOS ORGANISMOS PÚBLICOS LOCALES DE LAS ENTIDADES DE CAMPECHE, COLIMA, COAHUILA Y TAMAULIPAS, ASÍ COMO DE LAS CONSEJERÍAS ELECTORALES DE LOS ORGANISMOS PÚBLICOS LOCALES DE LAS ENTIDADES DE CHIAPAS, DURANGO, GUERRERO, HIDALGO, NAYARIT, ОАХАСА, PUEBLA, QUINTANA ROO, SINALOA, TAMAULIPAS, TLAXCALA Y VERACRUZ",
    titleAnexoPDF1: "FE DE ERRATAS",
  },
  {
    id: 478,
    typeDoc: "ACUERDO",
    numDoc: "INE/CG478/2026",
    nameDoc:
      "POR EL QUE SE APRUEBA EJERCER LA FACULTAD DE ATRACCIÓN PARA DETERMINAR FECHAS HOMOLOGADAS POR BLOQUES PARA LA CONCLUSIÓN DEL PERIODO DE PRECAMPAÑAS, ASÍ COMO PARA RECABAR APOYO DE LA CIUDADANÍA DE LAS PERSONAS ASPIRANTES A CANDIDATURAS INDEPENDIENTES, EN LOS PROCESOS ELECTORALES LOCALES CONCURRENTES CON EL PROCESO ELECTORAL FEDERAL 2026-2027",
  },
  {
    id: 571,
    typeDoc: "RESOLUCIÓN",
    numDoc: "INE/CG571/2026",
    nameDoc:
      "RESOLUCIÓN POR EL QUE SE APRUEBA EJERCER LA FACULTAD DE ASUNCIÓN PARCIAL EN LA VÍA EXPEDITA PARA IMPLEMENTAR EL CONTEO RÁPIDO EN LAS ELECCIONES DE GUBERNATURA DE LOS ESTADOS DE AGUASCALIENTES, BAJA CALIFORNIA, BAJA CALIFORNIA SUR, CAMPECHE, CHIHUAHUA, COLIMA, GUERRERO, MICHOACÁN, NAYARIT, NUEVO LEÓN, QUERÉTARO, QUINTANA ROO, SAN LUIS POTOSÍ, SINALOA, SONORA, TLAXCALA Y ZACATECAS DURANTE LOS PROCESOS ELECTORALES LOCALES 2026-2027.",
  },
];
